import React from "react";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import IconButton from "@material-ui/core/IconButton";
import CloseIcon from "@material-ui/icons/Close";
import { makeStyles } from "@material-ui/core/styles";
import { FlatButton } from "../FlatButton";

const useStyles = makeStyles({
  root: {
    fontFamily: "Source Sans Pro",
  },
  closeButton: {
    position: "absolute",
    right: 1,
    top: 1,
    color: "#707070",
  },
  content: {
    paddingBottom: 10,
    fontFamily: "Source Sans Pro",
    fontWeight: 500,
    fontSize: "16px",
    color: "#707070",
  },

  title: {
    fontFamily: "Source Sans Pro",
    fontWeight: 600,
    fontSize: "20px",
    color: "#202020",
  },

  hr: { width: "100%", color: "#707070" },
});

export default function SelectOrgSuccessDialogBox(props: {  
  state: boolean;
}) {
  const classes = useStyles();
  const [open, setOpen] = React.useState(props.state);

  const handleClose = () => {
    window.history.replaceState(null, '', '/residents')
    setOpen(false);
  };

  return (
    <div>
      <Dialog
        open={open}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        onBackdropClick={handleClose}
        onClose={handleClose}
      >
        <DialogTitle className={classes.title} id="alert-dialog-title">
          <span className={classes.title}> You have successfully linked your MedPoint account to an aged care provider.</span>
        </DialogTitle>
        <IconButton
          aria-label="close"
          className={classes.closeButton}
          onClick={handleClose}
          disableRipple
        >
          <CloseIcon />
        </IconButton>
        <DialogContent>
          <DialogContentText
            className={classes.content}
            id="alert-dialog-description"
          >
            To link to more providers, simply click on your name in the top right hand corner of any MedPoint screen and select “Link to another aged care provider
          </DialogContentText>
        </DialogContent>
        <hr className={classes.hr} />
        <DialogActions>
          <FlatButton
            type="button"
            kind="primary"
            css={{
              width: 104,
              alignSelf: "flex-end",
            }}
            onPress={handleClose}
          >
            OK
          </FlatButton>
        </DialogActions>
      </Dialog>
    </div>
  );
}
